import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-expiration-date-termination-date",
  // imports: [],
  templateUrl: "./expiration-date-termination-date.component.html",
  styleUrl: "./expiration-date-termination-date.component.css",
  standalone: false,
})
export class ExpirationDateTerminationDateComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
